import { assertNever, noop } from '@kofno/piper';
import ReactionComponent, { RCProps } from '../../../ReactionComponent';
import SegmentStore from '../../../SegmentStore';
import { autoSavingFormFields } from '../../SegmentReactions/Functions';
import { State as CoachSelectStoreState } from '../FormField/SelectField/CoachSelect/Store/Types';
import { State as DropdownFieldStoreState } from '../FormField/SelectField/Select/DropdownSelect/Store/Types';
import { FormFieldStore } from '../Types';

type FieldStoreState = CoachSelectStoreState | DropdownFieldStoreState;

interface Props extends RCProps<FormFieldStore> {
  segmentStore: SegmentStore;
}

class AutoSaveReactions extends ReactionComponent<FormFieldStore, FieldStoreState, Props> {
  tester = () => this.props.store.state;

  effect = (state: FieldStoreState) => {
    const { store, segmentStore } = this.props;
    switch (state.kind) {
      case 'initializing':
      case 'waiting':
      case 'ready':
        break;
      case 'auto-saving':
        autoSavingFormFields(segmentStore, noop, store.autoSaveComplete);
        break;
      default:
        assertNever(state);
    }
  };
}

export default AutoSaveReactions;
